/**
 * The date windows of the Customer Service dashboard, as the legacy screen used them.
 * yyyy-MM-dd in local time (toISOString would shift the day in Malaysia).
 */
import type { DateType } from '../types/customerService';

const pad = (value: number) => String(value).padStart(2, '0');

export const toIsoDate = (date: Date): string =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

export const today = () => new Date();

export const tomorrow = () => {
  const date = new Date();
  date.setDate(date.getDate() + 1);
  return date;
};

export const firstOfMonth = () => {
  const date = new Date();
  return new Date(date.getFullYear(), date.getMonth(), 1);
};

/** The vessel board looks back to here for arrivals that are still open. */
export const VESSEL_LOOKBACK_FROM = '2025-02-01';

/** Where the "without invoice" tile starts counting. */
export const UNBILLED_SINCE = '2024-10-01';

/** Pickups for today (0) or today + tomorrow (1). */
export const pickupWindow = (dateType: DateType) => ({
  fromDate: toIsoDate(today()),
  toDate: toIsoDate(dateType === 0 ? today() : tomorrow()),
});

/** Vessels: everything still open up to today (0), or today + tomorrow (1). */
export const vesselWindow = (dateType: DateType) => ({
  fromDate: dateType === 0 ? VESSEL_LOOKBACK_FROM : toIsoDate(today()),
  toDate: toIsoDate(dateType === 0 ? today() : tomorrow()),
});

/** The four tiles: month to date. */
export const monthToDate = () => ({ fromDate: toIsoDate(firstOfMonth()), toDate: toIsoDate(today()) });
